/**
 * @generated SignedSource<<7a42734fd6dc76ffe14557ffc6bc8d4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type RecentFilter = "ALL" | "COLLABORATED_ON" | "CREATED" | "WORKED_ON" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useRecentPreferencesUserPreferencesFragment$data = {
  readonly recentFilter: RecentFilter;
  readonly " $fragmentType": "useRecentPreferencesUserPreferencesFragment";
};
export type useRecentPreferencesUserPreferencesFragment$key = {
  readonly " $data"?: useRecentPreferencesUserPreferencesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecentPreferencesUserPreferencesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useRecentPreferencesUserPreferencesFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "recentFilter"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "2c1b5529f555004270b69bbda8b91b0d";

export default node;
